export default class NumberValueObject {

    /**
     * NumberValueObject constructor.
     *
     * @param {number} value
     */
    constructor(value) {
        this.value = value;
    }


}